// import Text from '../../atoms/Text';
import { INewsItem } from '../../reducers/news';
// import { timeDistance } from '../DexTrades/formatters';
import SliderCard from './SliderCard';

interface INewsBlockProps {
  items: INewsItem[];
  index: number;
  onClick(index: number): void;
}

const NewsBlock = ({ items, index, onClick }: INewsBlockProps) => {
  const goNext = () => {
    if (index === items.length - 1) {
      return onClick(0);
    }
    onClick(index + 1);
  };

  const goPrev = () => {
    if (index === 0) {
      return onClick(items.length - 1);
    }
    onClick(index - 1);
  };

  return (
    <>
      {/* Author */}
      {/* <div className='author'> */}
      {/* {items[index].authorIcon && <Image size='m' src={items[index].authorIcon} className="author__image" />} */}
      {/* <Text size={14} className="text--grey-600">{items[index].author}</Text> */}
      {/* <Text size={14} className='text--grey-600'>
          Mocked Author
        </Text>
        <Text size={12} className='text--grey-600'>
          &nbsp;&bull;&nbsp;
        </Text> */}
      {/* <Text size={14} className="text--grey-600">{timeDistance(items[index].created_at)} ago</Text> */}
      {/* <Text size={14} className='text--grey-600'>
          {timeDistance(1662584400000)} ago
        </Text> */}
      {/* </div> */}
      {/*  */}
      <div className='slider'>
        <div
          className='slider__row'
          style={{ transform: `translate(${-index * 300 - 10}px)` }}
        >
          {items.map((item: INewsItem) => (
            <SliderCard key={item.id} card={item} />
          ))}
        </div>
      </div>
      <div className='slider__nav'>
        <div
          className='slider__nav__btn icon-chevron-left'
          onClick={goPrev}
        />
        <div className='slider__nav__dots'>
          {Array(items.length)
            .fill({})
            .map((_, arrIndex) => (
              <div
                key={arrIndex}
                onClick={() => onClick(arrIndex)}
                className={`slider__nav__dots__item ${
                  index === arrIndex ? 'slider__nav__dots__item--active' : ''
                }`}
              />
            ))}
        </div>
        <div
          className='slider__nav__btn icon-chevron-right'
          onClick={goNext}
        />
      </div>
    </>
  );
};

export default NewsBlock;
